import React from "react";
import TimelineItem from "./TimelineItem";
import "./Experience.css";


function Experience() {

  const timelineItems = [
    {
      image: "/images/experience/rtx.png",
      imageUrl: "https://www.rtx.com/",
      roles: [
        {
          jobTitle: "Senior Software Engineer",
          date: "June 2025 - Present",
          description: `Since 2020, I have been working on a sea-based X-Band Radar (XBR) for mid-course missile defense that 
          is featured in the Netflix movie "Interceptor". 
          I am the Scrum Master of a six person team.
          As a Scrum Master, I lead Sprint Planning, create Sprint Retrospectives, and remove blockers for my team to maintain a consistent velocity.
          My development work generally consists of implementing new features that were designed by system engineers to stay
          ahead of evolving threats, as well as maintaining the current software builds. 
          Some of these features included updating an interface for new hardware, and re-implementing a static analysis tool from a deprecated library to a new one.
          Most of the radar software is written in Ada, C++ and C, but I have also updated MATLAB, Java, Perl, and Python tools. 
          I've updated the Jenkins pipeline that's run regularly and on git Pull Requests.
          I manage stories in Jira.
          I update technical documentation in Confluence and Word.
          I update requirements in DOORS.`
        },
        {
          jobTitle: "Software Engineer II",
          date: "January 2021 - June 2025",
          description: `As a Software Engineer II, I worked as an Individual Contributor and Product Owner on an Agile team of about 10 people.
          As a Product Owner, I presented team progress to the customer every sprint during Sprint Reviews, led Backlog Refinements, and broke requirements into stories.
          During these years, the features I developed include: updating two large radar GUIs into Qt, re-implementing an advanced radar algorithm, and updating radar communications from TCP to UDP multicast.
          I have experience with some obsolete technologies including: ClearCase for version control, iTracker and RTC for ticket management, and MediaWiki for documentation.
          I authored, moderated, and reviewed code reviews in Collaborator and iTracker.`
        },
        {
          jobTitle: "Graduate Intern",
          date: "June 2020 - December 2020",
          description: `As an intern, I created MATLAB integration tests to verify XBR radar simulation runs. 
          I also updated requirement tracing in DOORS.`
        }
      ]
    },
    {
      image: "/images/experience/insulet.png",
      imageUrl: "https://www.insulet.com/",
      roles: [
        {
          jobTitle: "Life-Cycle Engineering Intern",
          date: "June 2019 - August 2019",
          description: `I ported and automated unit tests from the previous Omnipod insulin management 
          product into VectorCAST software. I verified function control flow with VectorCAST.`
        }
      ]
    },
    {
      image: "/images/experience/gdms.png",
      imageUrl: "https://gdmissionsystems.com/",
      roles: [
        {
          jobTitle: "Software Engineering Intern",
          date: "June 2018 - July 2018",
          description: `I worked on a prototype for an embedded system designed to transfer an 
          encrypted bitstream from a keyloader device  to a military radio wirelessly. The prototype was simulated on 
          Raspberry Pis in a Linux environment using GPIO pins and signaling. Testing was performed 
          with oscilloscopes to assure the bitstream was being sent at the required frequency.`  
        }
      ]
    },
    {
      image:"/images/experience/wpi_side.png",
      imageUrl: "https://www.wpi.edu/",
      roles: [
        {
          jobTitle: "BS/MS Student",
          date: "August 2016 - December 2020",
          description: `I studied through the accelerated BS/MS program to 
          earn my Bachleor's and Master's in computer science in under five years. 
          My MQP capstone project was an IoT network security protocol to detect
          when a device was compromised to become part of a botnet.
          Over my schooling, I took a variety of courses in software
          engineering, operating systems, networks, algorithms, and cyber
          security. My Bachelor's degree has a concentration in cybersecurity. 
          I was the president and hackathon manager for the Association of Computing Machinery club, 
          and a member of the CyberSecurity Club.`
        }
      ]
    }
  ];


  return (
    <div id="experience-div" className="white-background">


        <h1>Experience</h1>


        {timelineItems.map(function(timelineItem, i) {
          return <TimelineItem
            key={i}
            image={timelineItem.image}
            imageUrl={timelineItem.imageUrl}
            roles={timelineItem.roles}/>;
        })}

{/* 
        <TimelineItem
        image="/images/experience/rtx.png"
        imageUrl="https://www.rtx.com/"
        roles={
          jobTitle: "Software Engineer II",
          date: "June 2020 - Present",
          description: "Software Engineer II. Graduate Intern. Created unit tests in MATLAB to verify radar requirements. <a>https://www.rtx.com/</a>"
        }
        />  
        
        
        <TimelineItem
        image="/images/experience/insulet.png"
        imageUrl="https://www.insulet.com/"
        jobTitle="Life-Cycle Engineering Intern"
        date="June 2019 - August 2019"
        description="Ported and automated unit tests from the previous product using VectorCAST software.
        Reviewed function control flow for correct behavior."/>

        <TimelineItem
        image="/images/experience/gdms.png"
        imageUrl="https://gdmissionsystems.com/"
        jobTitle="Software Engineering Intern"
        date="June 2018 - July 2018"
        description="Software Engineering Intern. Worked on a prototype for an embedded system designed to transfer an encrypted bitstream
        at a specific frequency. Programmed Raspberry Pi’s in a Linux environment using GPIO pins, signaling, and
        oscilloscope testing to simulate the embedded system and desired frequency."/>

        <TimelineItem
        image="/images/experience/wpi_side.png"
        imageUrl="https://www.wpi.edu/"
        jobTitle="BS/MS Student"
        date="August 2016 - December 2020"
        description="I studied computer science here. I graduated with my Bachleors of Science in Computer Science
        with a concentration in cybersecurity May 2020, and my Masters of Science in Computer Science in December 2020."/> */}

    </div>
  );
}

export default Experience;
